import React from 'react';
import Overlay from '@RHEnvironmental/pattern-library/dist/js/components/Overlay';
import { localise } from '../../../../services/lang/lang';
import { useGetInspectionSettings } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import ShareInspectionModalContent from './ShareInspectionModalContent';
const ShareInspectionModal = (props) => {
    const { data: response, isFetching, isError, error, } = useGetInspectionSettings(props.inspection.id);
    const inspectionSettings = unwrapModel(response);
    return (React.createElement(Overlay, { isOpen: true, autoHeight: "true", onClose: props.onClose, onRequestClose: props.onClose, title: localise('SHARE') },
        React.createElement(ShareInspectionModalContent, { onClose: props.onClose, isError: isError, isLoading: isFetching, inspectionSettings: inspectionSettings, error: error })));
};
export default ShareInspectionModal;
